"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotCtorArg = void 0;
/**
 * @public
 * {@inheritDoc IPlotCtorArg}
 */
class PlotCtorArg {
    constructor(chart, plotOptions, plotArea) {
        this.chart = chart;
        this.plotOptions = plotOptions;
        this.plotArea = plotArea;
    }
}
exports.PlotCtorArg = PlotCtorArg;
//# sourceMappingURL=plot-ctor-arg.js.map